import axios from 'axios';

export const api = axios.create({
  baseURL: (import.meta.env.VITE_API_URL || '') + '/api',
  withCredentials: true,
});

let isRefreshing = false;
let pendingRefreshResolvers: Array<(ok: boolean) => void> = [];

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const url = original?.url ?? '';
    if (url.includes('/auth/login') || url.includes('/auth/refresh') || url.includes('/auth/logout')) {
      throw error;
    }
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          pendingRefreshResolvers.push((ok) => {
            if (ok) resolve(api(original));
            else reject(error);
          });
        });
      }
      isRefreshing = true;
      try {
        await api.post('/auth/refresh');
        pendingRefreshResolvers.forEach((r) => r(true));
        pendingRefreshResolvers = [];
        return api(original);
      } catch (refreshErr) {
        pendingRefreshResolvers.forEach((r) => r(false));
        pendingRefreshResolvers = [];
        throw refreshErr;
      } finally {
        isRefreshing = false;
      }
    }
    throw error;
  },
);

export type ApiError = {
  statusCode: number;
  error?: string;
  message?: string | string[];
  issues?: unknown[];
};
